import { Col, Row } from 'react-bootstrap'
import { StatisticsWidget } from '../../dashboard/components/StatisticsWidget'
import { useIntl } from 'react-intl'
import { DisplayImage } from '../../widgets/components/General/DisplayImage'
import '../styles/compliance-meeting.scss'
import { ComplianceMeetingTableView } from '../components/meeting-table-view'
import Calendar from 'react-calendar'
import 'react-calendar/dist/Calendar.css'
import { useEffect, useState } from 'react'
import { meetingCountDown } from '../core/_util'
import { useAuth } from '../../auth'
import { acceptInvite, getMeetingStats } from '../core/_requests'
import Skeleton from 'react-loading-skeleton'
import SkeletonRow from '../../digital-signing/components/SkeletonRow'
import { Link, useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import { useDateFormat } from '../../../hooks/useDateFormat'
import { useTimeZone } from '../../../hooks/useTimeZone'

export const ComplianceMeeting = () => {
  const { currentUser, companyId } = useAuth()
  const email = currentUser?.email
  const [upcomingData, setUpcomingData] = useState<any>()
  const { formatMessage } = useIntl()
  const navigate = useNavigate()
  const { getDateValue } = useDateFormat()
  const location = useLocation()
  const [searchParams] = useSearchParams()
  const meetingId = searchParams.get('meetingId')
  const participantId = searchParams.get('participantId')
  const status = searchParams.get('status')
  const { getTimeZoneValue } = useTimeZone()
  const [loading, setLoading] = useState(false)
  const today = new Date() // eslint-disable-line
  const totalLength =
    upcomingData?.upcomingMeeting && upcomingData?.upcomingMeeting?.meetingParticipants.length
  const acceptedLength =
    upcomingData?.upcomingMeeting &&
    upcomingData?.upcomingMeeting?.meetingParticipants.filter(
      (data: any) => data.status === 'accept'
    ).length
  const participantList =
    upcomingData?.upcomingMeeting && upcomingData?.upcomingMeeting?.meetingParticipants
  const activeParticipant = upcomingData && upcomingData?.activeParticipant
  useEffect(() => {
    getMeetingDashboard()
    if (meetingId && participantId && status) {
      acceptInvited()
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const acceptInvited = async () => {
    if (!meetingId) return
    if (!participantId) return
    if (!status) return
    const {
      data: { success },
    } = await acceptInvite(meetingId, participantId, status)
    if (success) {
      toast.success(formatMessage({ id: 'Invite accepted.' }))
      navigate(location.pathname)
    }
  }
  const getMeetingDashboard = async () => {
    try {
      setLoading(true)
      const {
        data: { success, data },
      } = await getMeetingStats(companyId)
      if (success) {
        setUpcomingData(data)
      }
    } catch (e) {
      console.log(e)
    } finally {
      setLoading(false)
    }
  }
  const timeZone = localStorage.getItem('timeZone')
  return (
    <>
      <Row>
        <Col md={6} lg={3} sm={12}>
          <div className='bg-white rounded-2 mb-4' style={{ height: '300px' }}>
            <div className='stats-card-top px-6 pt-6 mb-2'>
              <p className='mb-0 text-muted mb-4'>{formatMessage({ id: 'Upcoming Meetings' })}</p>
              <div className='d-flex flex-row align-items-center mt-6'>
                {loading ? (
                  <Skeleton
                    height={48}
                    width={240}
                    baseColor='var(--kt-skeleton-bg-color)'
                    highlightColor='var(--kt-skeleton-highlight-bg-color)'
                  />
                ) : (
                  <h1 className='mb-0 dark_text_color font-size-32'>
                    {upcomingData?.numberOfUpcomingMeeting || 0}
                  </h1>
                )}
              </div>
            </div>
            <div className={`w-100 ${loading ? 'px-6' : 'px-6'}`}>
              {loading ? (
                <Skeleton
                  height={168}
                  count={1}
                  width={'100%'}
                  className='px-6'
                  baseColor='var(--kt-skeleton-bg-color)'
                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                />
              ) : (
                <StatisticsWidget
                  className='card-xl-stretch mb-xl-1 h-100'
                  color='primary'
                  statisticsData={upcomingData?.upcomingStats}
                  label='Upcoming Meeting'
                />
              )}
            </div>
          </div>
        </Col>

        <Col md={6} lg={3} sm={12}>
          <div className='bg-white rounded-2 mb-4' style={{ height: '300px' }}>
            <div className='stats-card-top px-6 pt-6 mb-2'>
              <p className='mb-0 text-muted mb-4'>{formatMessage({ id: 'Average Accept Invite' })}</p>

              <div className='d-flex flex-row align-items-center mt-6'>
                {loading ? (
                  <Skeleton
                    height={48}
                    width={240}
                    baseColor='var(--kt-skeleton-bg-color)'
                    highlightColor='var(--kt-skeleton-highlight-bg-color)'
                  />
                ) : (
                  <h1 className='mb-0 dark_text_color font-size-32'>{`${upcomingData?.avgAcceptInvite || 0
                    }%`}</h1>
                )}
              </div>
            </div>
            <div className={`w-100 ${loading ? 'px-6' : 'px-6'}`}>
              {loading ? (
                <Skeleton
                  height={168}
                  count={1}
                  width={'100%'}
                  className='px-6'
                  baseColor='var(--kt-skeleton-bg-color)'
                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                />
              ) : (
                <StatisticsWidget
                  className='card-xl-stretch mb-xl-1 h-100'
                  color='primary'
                  statisticsData={upcomingData?.acceptInviteStat}
                  label='users'
                />
              )}
            </div>
          </div>
        </Col>

        <Col md={6} lg={3} sm={12}>
          <div
            className='bg-white rounded-2 mb-4 d-flex flex-column justify-content-between'
            style={{ height: '300px' }}
          >
            <div className='stats-card-top px-6 pt-6 mb-2'>
              <p className='mb-0 text-muted mb-4'>{formatMessage({ id: 'Active Participants' })}</p>
              <div className='d-flex flex-row align-items-center mt-6'>
                {loading ? (
                  <Skeleton
                    height={140}
                    width={240}
                    baseColor='var(--kt-skeleton-bg-color)'
                    highlightColor='var(--kt-skeleton-highlight-bg-color)'
                  />
                ) : (
                  <h1 className='mb-0 dark_text_color font-size-32'>
                    {activeParticipant?.length || 0}
                  </h1>
                )}
              </div>
            </div>
            <div className='stats-card-top px-6 mb-4'>
              {/* {loading ? (
                <Skeleton
                  height={40}
                  count={1}
                  width={'100%'}
                  className='px-6'
                  baseColor='var(--kt-skeleton-bg-color)'
                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                />
              ) : ( */}
              <p className='mb-0 text-muted mb-4'>{formatMessage({ id: 'Active Members' })}</p>
              {/* // )} */}
              <div className='d-flex flex-row align-items-center'>
                {loading ? (
                  <div className='w-100'>
                    <Skeleton
                      height={30}
                      count={1}
                      width={'100%'}
                      className=''
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  </div>
                ) : (
                  <div className='d-flex align-items-center w-100 w-md-auto'>
                    {activeParticipant && activeParticipant.length > 0 ? (
                      <>
                        {activeParticipant
                          .slice(0, activeParticipant.length > 6 ? 6 : activeParticipant.length)
                          .map((data: any, index: number) => (
                            <DisplayImage
                              key={index}
                              imgName={data?.fileName || data?.name}
                              isUserAvatarWithLetter={data?.fileName ? false : true}
                              alt={formatMessage({ id: 'profile' })}
                              fit='cover'
                              width={data?.fileName || data?.name ? 24 : 16}
                              height={data?.fileName || data?.name ? 24 : 16}
                              className={
                                data?.fileName || data?.name
                                  ? index === 0
                                    ? 'c-profile me-n3'
                                    : 'c-profile ms-n3'
                                  : 'me-3'
                              }
                            />
                          ))}
                        {activeParticipant.length > 6 && (
                          <span className='ms-2'>+{activeParticipant.length - 6}</span>
                        )}
                      </>
                    ) : (
                      <>
                        <p className='text-dark'>-</p>
                      </>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </Col>

        <Col md={6} lg={3} sm={12}>
          <div
            className='bg-white rounded-2 d-flex justify-content-center p-2'
            style={{ height: '300px' }}
          >
            {loading ? (
              <Skeleton
                height={200}
                count={1}
                width={'100%'}
                className='rounded-2'
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
              />
            ) : (
              <Calendar
                value={today}
                tileClassName={({ date, view }) => {
                  const upcomingDatesArray =
                    upcomingData?.listOfComingDates?.map((detail: any) => new Date(detail)) || []
                  if (view === 'month') {
                    const isMatchingDate = upcomingDatesArray.some((meetingDate: any) => {
                      return (
                        date.getDate() === meetingDate.getDate() &&
                        date.getMonth() === meetingDate.getMonth() &&
                        date.getFullYear() === meetingDate.getFullYear()
                      )
                    })
                    if (isMatchingDate) {
                      return 'selected'
                    }
                  }
                  return ''
                }}
                className='border border-transparent bg-transparent text-dark'
              />
            )}
          </div>
        </Col>
      </Row>

      {upcomingData?.upcomingMeeting && (
        <>
          <div className='border p-4 rounded bg-white shadow-sm mt-4'>
            <Row className='align-items-start'>
              <Col xs={12} md={6}>
                <Link
                  to={`../view/after-meeting?meetingId=${upcomingData?.upcomingMeeting?.meetingId}`}
                  className='text-dark'
                >
                  <h4 className='text-muted font-size-12 font-weight-400'>
                    {formatMessage({ id: 'Next Meeting' })}
                  </h4>

                  <h4 className='text-dark font-size-20 font-weight-700'>
                    {upcomingData?.upcomingMeeting?.meetingTitle}
                  </h4>
                  <p className='text-dark font-size-16 font-weight-400'>
                    {getDateValue(upcomingData?.upcomingMeeting?.meetingDate.toString())}{' '}
                    {` |  ${getTimeZoneValue(upcomingData?.upcomingMeeting?.startTime)}`}{' '}
                    {`(${timeZone})`}
                  </p>
                </Link>
              </Col>
              <Col
                xs={12}
                md={6}
                className='d-flex flex-column flex-md-row flex-column-reverse align-items-center gap-4 flex-end'
              >
                {loading ? (
                  <Skeleton
                    height={40}
                    count={1}
                    width={200}
                    className='my-2 ms-3'
                    baseColor='var(--kt-skeleton-bg-color)'
                    highlightColor='var(--kt-skeleton-highlight-bg-color)'
                  />
                ) : (
                  <>
                    {upcomingData?.upcomingMeeting?.meetingParticipants.find(
                      (data: any) => data.email === email && data.status !== 'reject'
                    ) && (
                        <>
                          <div className='font-size-14 font-weight-400 w-100 w-md-auto text-center'>
                            {meetingCountDown(
                              upcomingData?.upcomingMeeting?.meetingDate,
                              upcomingData?.upcomingMeeting?.startTime
                            )}
                          </div>
                          <a
                            href={upcomingData?.upcomingMeeting?.link}
                            target='_blank'
                            rel='noopener noreferrer'
                          >
                            <button className='btn btn-primary w-100 w-md-auto'>
                              {formatMessage({ id: 'Join Meeting' })}
                            </button>
                          </a>
                        </>
                      )}
                  </>
                )}
              </Col>
            </Row>
            {loading ? (
              <Skeleton
                height={20}
                count={1}
                width={'50%'}
                className='my-2 ms-3'
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
              />
            ) : (
              <div className='my-3'>
                <p className='text-dark font-size-12 fw-regular'>
                  {upcomingData?.upcomingMeeting?.description}
                </p>
              </div>
            )}

            <div className='d-flex flex-column flex-md-row align-items-center gap-md-8 gap-4 my-4'>
              {loading ? (
                <SkeletonRow count={5} />
              ) : (
                <>
                  <div className='d-flex align-items-center w-100 w-md-auto'>
                    {participantList
                      ?.slice(0, totalLength > 6 ? 6 : totalLength)
                      .map((data: any, index: number) => (
                        <DisplayImage
                          key={index}
                          imgName={data.profileImage.name || data?.name}
                          isUserAvatarWithLetter={data?.profileImage?.name ? false : true}
                          alt={formatMessage({ id: 'profile' })}
                          fit='cover'
                          width={data.profileImage.name ? 24 : 16}
                          height={data.profileImage.name ? 24 : 16}
                          className={
                            data.profileImage.name
                              ? index === 0
                                ? 'c-profile me-n3'
                                : 'c-profile ms-n3'
                              : 'me-3'
                          }
                        />
                      ))}
                    {totalLength > 6 && <span className='ms-2'>+{totalLength - 6}</span>}
                  </div>

                  <div className='w-100'>
                    <div className='fw-medium mb-2 font-size-14 text-muted'>
                      {formatMessage({ id: 'Accepted Invites:' })} {acceptedLength}/{totalLength}
                    </div>
                    <div className='col-md-10 h-6px progress bg-grey w-100'>
                      <div
                        className='progress-bar bg-primary'
                        role='progressbar'
                        style={{ width: `${(acceptedLength / totalLength) * 100}%` }}
                      ></div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </>
      )}

      <div className='mb-6'>
        <ComplianceMeetingTableView />
      </div>
    </>
  )
}
